import React, { useContext, useState, useEffect } from 'react'
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
    Grid,
    Stack,
    Button,
    TextField,
    Typography,
    IconButton,
    FormControl,
    Select,
    MenuItem, InputAdornment, FormHelperText
} from "@mui/material";
import "../../Style/dialogstyle.scss";
import { BiMinusCircle } from "react-icons/bi";
//date picker
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useLazyQuery, useMutation } from "@apollo/client";
//src
import { CREATE_REQ_PURCHASE } from "../../Schema/Reqpurchase";
import { AuthContext } from "../../Context/AuthContext";
import ListPurchase from './ListPurchase';
import { SelectSupplier } from "../Include/DynamicSelect";

const CreateReqPurchase = ({ open, handleClose, setRefetch, dialogTitle }) => {

    // 
    const { setAlert } = useContext(AuthContext);

    // Hook
    const [loading, setLoading] = useState(false)
    const [selectSupplier, setSelectedSupplier] = useState({ id: "", title: "" })
    const [requireField, setRequireField] = useState(false);

    //
    const calculateSubTotal = () => {
        let subTotal = 0;
        listData.forEach((item) => {
            // subTotal += (parseFloat(item.itemQty) || 0) * (parseFloat(item?.itemId?.price) || 0);
            subTotal += (parseFloat(item.qty) || 0) * (parseFloat(item?.unitPrice) || 0);
        });
        return subTotal.toFixed(2);
    };

    const listReqPurchMaterial = {
        materialId: { id: "", title: "" },
        listMaterialUnitId: { id: "", title: "" },
        unitPrice: 0,
        checkUnitPrice: 200,
        qty: 0,
        image: "",
        key: Date.now() + Math.random(),
    }

    const [listData, setListData] = useState([listReqPurchMaterial]);

    //createReqPurchase
    const [createReqPurchase] = useMutation(CREATE_REQ_PURCHASE, {
        onCompleted: ({ createReqPurchase }) => {
            // console.log("createReqPurchase::", createReqPurchase)
            setLoading(false);
            if (createReqPurchase?.status) {
                setAlert(true, "success", createReqPurchase?.message);
                handleClose();
                resetForm();
                setRefetch();
                setSelectedSupplier({ id: "", title: "" })
                setListData([listReqPurchMaterial])
            } else {
                setAlert(true, "error", createReqPurchase?.message);
                console.log("error::", createReqPurchase?.message)
            }
        },
        onError: (error) => {
            setLoading(false);
            setAlert(true, "error", error?.message)
            console.log("error::", error)
        }
    })
    //formik
    const CheckValidation = Yup.object().shape({
        needDate: Yup.date().required("ទាមទារ!"),
        priority: Yup.string().required("ទាមទារ!"),
        remark: Yup.string(),
        shippingFee: Yup.number().min(0).required("ទាមទារ!"),
        supplierId: Yup.string().required("ទាមទារ!"),
    })

    const formik = useFormik({
        initialValues: {
            needDate: new Date(),
            priority: "Important",
            remark: "",
            shippingFee: 0,
            supplierId: ""
        },
        validationSchema: CheckValidation,
        onSubmit: async (values) => {

            let createStatus = false;
            const BreakException = {};
            try {
                if (listData?.length !== 0) {
                    listData?.forEach(function (elem) {
                        // console.log("element: ", elem)
                        if (
                            elem?.materialId?.id !== undefined &&
                            elem?.materialId?.id !== "" &&
                            elem?.listMaterialUnitId?.id !== undefined &&
                            elem?.listMaterialUnitId?.id !== "" &&
                            elem?.unitPrice > 0 &&
                            elem?.qty > 0
                        ) {
                            createStatus = true;
                        } else {
                            setLoading(false);
                            setRequireField(true);
                            createStatus = false;
                            throw BreakException;
                        }
                    });
                } else {
                    setLoading(false);
                    setRequireField(true);
                }
            } catch (e) {
                if (e !== BreakException) throw e;
            }

            if (createStatus) {
                let listReqPurchMaterialToSubmit = listData.map((d) => {
                    return {
                        listMaterialUnitId: d?.listMaterialUnitId?.id,
                        unitPrice: d?.unitPrice,
                        qty: d?.qty,
                        key: d?.key,
                    }
                })

                setLoading(true);
                createReqPurchase({
                    variables: {
                        input: {
                            ...values,
                            // amount: total,
                            requestMaterials: listReqPurchMaterialToSubmit,
                        }
                    }
                })
            }
        }
    })

    const {
        errors,
        touched,
        handleSubmit,
        getFieldProps,
        setFieldValue,
        values,
        resetForm,
    } = formik;

    useEffect(() => {
        setFieldValue("supplierId", selectSupplier?.id ? selectSupplier?.id : "")
    }, [selectSupplier?.id])

    const total = parseFloat(calculateSubTotal()) + parseFloat(values?.shippingFee);

    return (
        // <Dialog open={open} className="dialog-container" fullWidth maxWidth="lg">
        <Dialog open={open} className="dialog-container" fullWidth maxWidth="xl">
            <DialogTitle sx={{ padding: "10px 15px 10px 20px" }}>
                <Stack direction="row" justifyContent="space-between">
                    <Stack direction="column" justifyContent="center">
                        <Typography className='dialog-title'>បង្កើតការស្នើទិញ</Typography>
                    </Stack>
                    <Stack direction="column" justifyContent="center">
                        <IconButton onClick={handleClose}>
                            <BiMinusCircle className="close-icon" />
                        </IconButton>
                    </Stack>
                </Stack>
            </DialogTitle>
            <DialogContent dividers>
                <FormikProvider value={formik}>
                    <Form noValidate autoComplete='off' onSubmit={handleSubmit}>
                        <Grid container rowSpacing={2} columnSpacing={3}>
                            <Grid item xs={4}>
                                <Typography className='field-title'>អាទិភាព</Typography>
                                <FormControl fullWidth size='small'>
                                    <Select
                                        value={values.priority}
                                        onChange={(e) => setFieldValue("priority", e.target.value)}
                                    >
                                        <MenuItem value="Urgent">​ប្រញ៉ាប់​</MenuItem>
                                        <MenuItem value="Important">​សំខាន់​</MenuItem>
                                        <MenuItem value="Meduim">​មធ្យម​</MenuItem>
                                        <MenuItem value="Low">​តិចតួច​</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography className='field-title'>កាលបរិច្ឆេទ</Typography>
                                <LocalizationProvider dateAdapter={AdapterDateFns} sx={{ bgcolor: "red" }}>
                                    <DatePicker
                                        fullWidth
                                        value={values?.needDate}
                                        onChange={(e) => setFieldValue("needDate", e)}
                                        slotProps={{
                                            textField: {
                                                size: "small",
                                                fullWidth: true,
                                            },
                                        }}
                                        renderInput={(params) => (
                                            <TextField {...params} size="small" fullWidth />
                                        )}
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography className='field-title'>អ្នកផ្គត់ផ្គង់</Typography>
                                <SelectSupplier
                                    selectedVal={selectSupplier}
                                    setSelectedVal={setSelectedSupplier}

                                />
                                {!!errors.supplierId && touched.supplierId && (
                                    <FormHelperText errorid="outlined-adornment-password">
                                        {errors.supplierId}
                                    </FormHelperText>
                                )}
                            </Grid>
                            <Grid item xs={12}>
                                <Typography className='dialog-title-view'>
                                សម្ភារៈ
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <ListPurchase
                                    listData={listData}
                                    setListData={setListData}
                                    requireField={requireField}
                                    dialogTitle={dialogTitle} 
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Typography className='field-title'>ចំណាំ</Typography>
                                <TextField
                                    className='text-field'
                                    fullWidth
                                    multiline
                                    size='small'
                                    placeholder='ចំណាំ'
                                    {...getFieldProps("remark")} />
                            </Grid>

                            <Grid item xs={8}></Grid>
                            <Grid item xs={4}>
                                <Stack direction="column" spacing={1}>
                                    <Stack direction="row" width="100%">
                                        <Stack width={"32%"}>
                                            <Typography className='total-title'>តម្លៃ</Typography>
                                        </Stack>
                                        <Stack width={"18%"}>
                                            <Typography className='total-title'>:</Typography>
                                        </Stack>
                                        <Stack direction={"row"} width={"50%"} justifyContent={"space-between"} className='total-boz'>
                                            <Typography className='total-boz-letter'>$</Typography>
                                            <Typography className='total-boz-letter'>{calculateSubTotal()}</Typography>
                                        </Stack>
                                    </Stack>

                                    <Stack direction="row" width={"100%"}>
                                        <Stack justifyContent="center" width={"32%"}>
                                            <Typography className='total-title'>ថ្លៃដឹកជញ្ជូន</Typography>
                                        </Stack>
                                        <Stack justifyContent="center" width={"18%"}>
                                            <Typography>:</Typography>
                                        </Stack>
                                        <Stack direction={"row"} width={"50%"} justifyContent={"space-between"} className='total-boz'>
                                            <TextField
                                                inputProps={{ min: 0 }}
                                                className='text-field-right'
                                                fullWidth
                                                type='number'
                                                size='small'
                                                InputProps={{
                                                    startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                                }}
                                                sx={{
                                                    "& .css-1ua80n0-MuiInputBase-input-MuiOutlinedInput-input": { textAlign: "right" }
                                                }}
                                                {...getFieldProps("shippingFee")}
                                                error={Boolean(touched.shippingFee && errors.shippingFee)}
                                                helperText={touched.shippingFee && errors.shippingFee} />
                                        </Stack>
                                    </Stack>

                                    <Stack direction="row" width={"100%"}>
                                        <Stack justifyContent="center" width={"32%"}>
                                            <Typography className='total-title'>តម្លៃសរុប</Typography>
                                        </Stack>
                                        <Stack justifyContent="center" width={"18%"}>
                                            <Typography className='total-title'>:</Typography>
                                        </Stack>
                                        <Stack direction={"row"} width={"50%"} justifyContent={`space-between`} className='total-boz'>
                                            <Typography className='total-boz-letter'>$</Typography>
                                            <Typography className='total-boz-letter'>{total ? total.toFixed(2) : "0.00"}</Typography>
                                        </Stack>
                                    </Stack>
                                </Stack>

                            </Grid>

                            <Grid item xs={12}>
                                {loading ? (
                                    <Button className="btn-create" fullWidth>
                                        កំពុងដំណើរការ...
                                    </Button>
                                ) : (
                                    <Button
                                        className="btn-create"
                                        fullWidth
                                        onClick={handleSubmit}
                                    >
                                        បង្កើត
                                    </Button>
                                )}
                            </Grid>
                        </Grid>
                    </Form>
                </FormikProvider>
            </DialogContent>
        </Dialog>
    )
}

export default CreateReqPurchase